import TableBody from 'components/TableBody';
import { useGetRankingListQuery } from 'hooks/queries/rank';

const RankTable = () => {
	const {
		data: rank_data = null,
		isLoading: rank_loading,
		isFetching: rank_fetching,
	} = useGetRankingListQuery();

	const loading = rank_loading || rank_data === null || rank_fetching;

	return <TableBody data={rank_data?.results} loading={loading} />;
};

export default RankTable;
